import React from "react";
import PropTypes from 'prop-types'
import styled from "styled-components";
import { connect } from 'react-redux'
import * as Yup from 'yup'
import { Row, Col, Modal, Icon, Typography } from 'antd'
import { FastField, Formik } from 'formik'
import typo, { MESSAGE } from '../../../../constants/dictionaries'

// Components
import Input from '../../../Common/Input'
import Button from '../../../Buttons'
import ValidatedText from "../../../Common/ValidatedText";
import DisplayFormikState from "../../../Table/DisplayFormikState";
import Api from '../../../../api';
import Message from "../../../Messages";
import constants from "../../../../constants/constant"
import helper from "../../../../helper/helper"
import Select from "../../../Common/Select"
import Api_tnn from "../../../../api/api.tnn";
import Api_quantrac from "../../../../api/api.quantrac";
import Api_spatial from "../../../../api/api.spatial";
import TramQT_QN from "../../../../models/QuanTrac_qn/TramQuanTrac";
const { Text } = Typography;
const schema = Yup.object().shape({
  tenTram: Yup.string().required(typo.cscore_required),
  diaDiem: Yup.string().required(typo.cscore_required),
});
const ControllerInput = styled.div`
  padding: 0 20px 0 20px;
`;
class AddTramModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {},
      data_KinhTuyenTruc: [],
      data_tinh: [],
      data_huyen: [],
      data_xa: [],
    };
  }
  componentDidMount() {
    this.GetApidmkinhtuyentrucs(constants.CAP_TRIEN_KHAI)
    this.getApiTinhs();
    this.getApiHuyenByTinhs(constants.MA_TINH);
    this.setState({
      initialValues: {
        ...this.state.initialValues,
        loai_KTT: constants.CAP_TRIEN_KHAI,
        muiChieu: constants.CAP_TRIEN_KHAI === 2 ? 3 : 6,
        kinhTuyenTruc: constants.KINH_TUYEN_TRUC,
        ten_KTT: constants.KINH_TUYEN_TRUC_TEN,
        maTinh: constants.CAP_TRIEN_KHAI === 2 ? constants.MA_TINH : undefined,
      }
    })
  }
  getApiTinhs = () => {
    new Api()
      .getTinhs({ token: this.props.user.access_token, })
      .then(res => { this.setState({ data_tinh: res }); });
  };
  getApiHuyenByTinhs = (maTinh) => {
    new Api()
      .getHuyenByTinhs({
        token: this.props.user.access_token,
        maTinh: maTinh
      })
      .then(res => { this.setState({ data_huyen: res }) });
  };
  getApiXaByHuyens = (mahuyen) => {
    new Api()
      .getXaByHuyens({
        token: this.props.user.access_token,
        maHuyen: mahuyen
      })
      .then(res => { this.setState({ data_xa: res }) });
  };
  GetApidmkinhtuyentrucs = (cap) => {
    new Api()
      .Getdmkinhtuyentrucs({ token: this.props.user.access_token, page: "0", size: "0", cap: cap })
      .then(res => { this.setState({ data_KinhTuyenTruc: res.data }); })
      .catch(err => {
        Message.error(err.message)
      });
  };
  onSelectLKTT = (value) => {
    this.GetApidmkinhtuyentrucs(value)
  }
  render() {
    const {
      isOpen = false,
      handleAdd,
      handleCancel,
      ApiPost,
      ApiSpatial,
      user } = this.props
    const { data_xa, data_huyen, data_tinh, initialValues, data_KinhTuyenTruc } = this.state
    return (
      <Modal
        visible={isOpen}
        title={"Thêm mới vị trí quan trắc"}
        footer={false}
        onCancel={handleCancel}
        width="700px"
      >
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={async (values, actions) => {
            var tenDVHCTram = helper.gettenDVHC(data_xa, data_huyen, data_tinh, values.maXa, values.maHuyen, values.maTinh)
            const { degree, minute } = await helper.getKTTById(user.access_token, values.kinhTuyenTruc);
            ApiPost({
              token: user.access_token,
              data: { ...values, loaiTram: 2, tenDVHC: tenDVHCTram }
            })
              .then(res => {
                handleAdd(values);
                Message.success(MESSAGE.CSCORE_ADD_SUCCESS)
                if (values.toaDo !== undefined && values.toaDo !== null && values.toaDo !== "" && ApiSpatial) {
                  ApiSpatial({
                    token: this.props.user.access_token,
                    obj: {
                        toados: values.toaDo,
                        idTramQuanTrac: res.id,
                        tenTram: values.tenTram,
                        loaitram: 2,
                        diaDiem: values.diaDiem,
                      },
                    ktt_do: degree,
                    ktt_phut: minute,
                    muichieu: values.muiChieu
                  }).then(resSpatial => { })
                    .catch(err => {
                      // Message.error(err.message)
                    })
                }
              }) 
              .catch((err) => Message.error(err.message))
          }}
          validationSchema={schema}
          render={({ handleChange, handleSubmit, values, errors, touched, setFieldValue }) => (
            <form onSubmit={handleSubmit} autoComplete={false}>
              <Row>
                <Col span={12}>
                  <ControllerInput>
                    <FastField
                      name="tenTram"
                      render={({ field }) => <Input label={typo.cscore_ten_tram} id="tenTram" {...field} />}
                    />
                    {touched.tenTram && <ValidatedText type="danger">{errors.tenTram}</ValidatedText>}

                    <FastField
                      name="diaDiem"
                      render={({ field }) => <Input label={typo.cscore_hydropower_place} id="diaDiem" {...field} />}
                    />
                    {touched.diaDiem && <ValidatedText type="danger">{errors.diaDiem}</ValidatedText>}
                    <Select
                      mandatory={false}
                      placeholder={helper.genSelectPL(typo.cscore_province_placeholder)}
                      label={typo.cscore_province}
                      onChange={(value, name) => {
                        setFieldValue("maTinh", value);
                        { setFieldValue("maHuyen", undefined) };
                        { setFieldValue("maXa", undefined) };
                        this.getApiHuyenByTinhs(value)

                      }}
                      dataSource={data_tinh}
                      width="100%"
                      name="tenDVHC"
                      name_value="maTinh"
                      value={values.maTinh}
                    />

                    <Select
                      mandatory={false}
                      placeholder={helper.genSelectPL(typo.cscore_district_placeholder)}
                      label={typo.cscore_district}
                      onChange={(value, name) => {
                        setFieldValue("maHuyen", value);
                        { setFieldValue("maXa", undefined) };
                        this.getApiXaByHuyens(value)
                      }}
                      dataSource={data_huyen}
                      width="100%"
                      name="tenDVHC"
                      name_value="maHuyen"
                      value={values.maHuyen}
                    />

                    <Select
                      mandatory={false}
                      placeholder={helper.genSelectPL(typo.cscore_ward_placeholder)}
                      label={typo.cscore_ward}
                      onChange={(value, name) => {
                        setFieldValue("maXa", value);
                      }}
                      dataSource={data_xa}
                      width="100%"
                      name="tenDVHC"
                      name_value="maXa"
                      value={values.maXa}
                    />
                  </ControllerInput>
                </Col>
                <Col span={12}>
                  <ControllerInput>
                    <FastField name="toaDo" validate={helper.validateToaDo} render={({ field }) => (<Input mandatory={false} label={typo.cscore_toa_do} {...field} placeholder={typo.cscore_toaDo} />)} />
                    {touched.toaDo && (<Text type="danger">{errors.toaDo}</Text>)}

                    <Select
                      dataSource={constants.CAP_THAM_QUYEN}
                      label={typo.cscore_loaiKTT}
                      onChange={(value) => { setFieldValue("loai_KTT", value); this.onSelectLKTT(value) }}
                      placeholder={helper.genSelectPL(typo.cscore_chon_cap)}
                      mandatory={false}
                      width="100%"
                      name="ten"
                      name_value="id"
                      value={values.loai_KTT ? Number(values.loai_KTT) : undefined}
                    />

                    <Select
                      mandatory={false}
                      placeholder={helper.genSelectPL(typo.cscore_kinh_tuyen_truc)}
                      label={typo.cscore_kinh_tuyen_truc}
                      onChange={(value, name) => { setFieldValue("kinhTuyenTruc", value); setFieldValue("ten_KTT", name.props.children) }}
                      dataSource={data_KinhTuyenTruc}
                      width="100%"
                      name="ten"
                      name_value="id"
                      value={values.kinhTuyenTruc ? Number(values.kinhTuyenTruc) : undefined}
                    />

                    <Select
                      mandatory={false}
                      placeholder={helper.genSelectPL(typo.cscore_mui_chieu)}
                      label={typo.cscore_mui_chieu}
                      onChange={value => setFieldValue("muiChieu", value)}
                      dataSource={constants.MUI_CHIEU}
                      width="100%"
                      name="ten"
                      name_value="id"
                      value={values.muiChieu ? Number(values.muiChieu) : undefined}
                    />
                  </ControllerInput>
                </Col>
              </Row>
              <div className="mt-20" />
              <Row type="flex" justify="end" align="middle">
                <Button type="submit" onClick={handleSubmit}><Icon type="save" />{typo.cscore_save}</Button>
                <div className="ml-10" />
                <Button type="cancel" onClick={handleCancel}><Icon type="arrow-right" />{typo.cscore_exit}</Button>
              </Row>
              {/*<DisplayFormikState error={errors} value={values}/>*/}
            </form>
          )} />
      </Modal>
    )
  };
}


AddTramModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  handleAdd: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
};

const mapStateToProps = (store) => ({
  user: store.oidc.user
});

export default connect(mapStateToProps)(AddTramModal);

